module.exports = __webpack_public_path__ + "img/cake.15feaa98.png";